import { useCallback, useMemo } from 'react';
import { getCurationNavigationState } from '../../state/Catalog';

type ProductLike = Maybe<{ id: string }>;

export const tryGetStoredCurationForProduct = (product: ProductLike) => {
  const curationFromStorage = getCurationNavigationState();
  return product && curationFromStorage?.children && curationFromStorage.children.some(id => id === product.id) ? curationFromStorage : null;
};

export const useStoredCuration = (product: ProductLike) => {
  const getRelatedCuration = useCallback((product: ProductLike) => {
    return tryGetStoredCurationForProduct(product);
  }, []);

  const storedCuration = useMemo(() => {
    return getRelatedCuration(product);
  }, [getRelatedCuration, product]);

  return { storedCuration, getRelatedCuration } as const;
};
